export default __webpack_public_path__ + "images/anuj.13f56bb70a0bc4269373.png";